class SearchButton {
  constructor(activator) {
    this.els = [];
    Array.from(document.querySelectorAll(".nav-item.tab a")).forEach((e, i) => {
      e.onclick = (e) => { this.onClick(e); };
      this.els.push(e);
    });
  }

  onClick(e) {
    e.preventDefault();

    var panels = [];

    var tab = e.srcElement;

    var tabCollapse = null;

    var classesAdd = [];
    var classesRemove = [];

    this.els.forEach((el) => {
      if (el !== tab) {
        classesAdd = [];
        classesRemove = ["active", "show"];
      }
      else {
        classesAdd = ["active", "show"];
        classesRemove = [];
      }

      tabCollapse = document.querySelector(el.dataset.target);

      classesAdd.forEach((ca) => {
        el.classList.add(ca);
        if (tabCollapse != null) {
          tabCollapse.classList.add(ca);
        }
      });

      classesRemove.forEach((cr) => {
        el.classList.remove(cr);
        if (tabCollapse != null) {
          tabCollapse.classList.remove(cr);
        }
      });
    });
  }
}

if (document.querySelectorAll(".nav-item.tab a").length) {
  window.SearchButton = new SearchButton();
}